<div *ngIf="data" class="profile-box-area">
  <div class="d-flex">
    <div class="profile-box-img mr-2">
      <img
        *ngIf="data?.logoUrl !== ' '"
        src="{{ data.logoUrl }}"
        onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';"
        alt="profile-image"
      />
      <img
        *ngIf="data.logoUrl === ' '"
        src="assets/images/person-ic.jpg"
        onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';"
        alt="profile-image"
      />
    </div>
    <div class="profile-box-info">
      <h3>{{ data.companyName }}</h3>
      <div>
        <ngx-stars
          #ratingChange
          initialStars="{{ data?.rating }}"
          totalstars="{{ totalstar }}"
          [color]="'#51af57'"
          size="24px"
          [readonly]="true"
        ></ngx-stars>
      </div>
      <!-- <div class="reviews-number">
        {{ data.rating }} Ratings and {{ data.reviews }} Reviews
      </div> -->
      <div class="reviews-number">
        {{ data.rating }}
        {{ data.rating > 1 ? "Ratings" : "Rating" }}
        and
        {{ data.reviews }}
        {{ data.reviews > 1 ? "Reviews" : "Review" }}
      </div>
    </div>
  </div>
</div>
